<template>
  <div>
    <h3 v-if="!hideHeader">
      {{ title(ownershipType) }}(s)
    </h3>
    <p>
      <span v-for="(co, i) in owners" :key="i">
        <span v-if="co.isPrimary">
          <v-tooltip dark right>
            <template v-slot:activator="{ on, attrs }">
              <font-awesome-icon icon="paw" color="primary"
                v-bind="attrs" v-on="on" />
            </template>
            <span>{{ tooltipText(ownershipType) }}</span>
          </v-tooltip>
        </span>
        <span v-else>
          <font-awesome-icon icon="paw" color="transparent" />
        </span>
        <b>
          &nbsp;
          <a :href="`/admin/people/${co.personId}`" target="_blank">
          {{ co.firstName }} {{ co.lastName }}
          </a>
          <span v-if="co.memberId">&nbsp;(Member ID: {{ co.memberId }}<span v-if="co.membershipDuration"> for {{co.membershipDuration}} years</span>)</span>
        </b>
        <br />
        <span v-if="!hideContactInfo">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span v-if="co.email">{{
            co.email
          }}</span
          ><span v-else>No email</span>
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span v-if="co.phoneNumber">{{
            co.phoneNumber
          }}</span
          ><span v-else>No phone</span>
          <br />
        </span>  
      </span>
    </p>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export enum OwnershipType {
  Dog = 1,
  Lease = 2,
  Litter = 3,
  Kennel = 4,
}

export default Vue.extend({
  name: "CoownersList",
  data: function() {
    return {};
  },
  methods: {
    title(ownershipType: OwnershipType) {
      if (ownershipType == OwnershipType.Lease) {
        return "Lessee";
      } else {
        return "Owner";
      }
    },
    tooltipText(ownershipType: OwnershipType){
        if(ownershipType == OwnershipType.Lease){
            return "Only the primary lessee can register litters, release and register puppies. They will also be a primary contact person for the ASCA office.";
        }
        if(ownershipType == OwnershipType.Dog){
            return "Only the primary owner can register litters, and lease the dog. They will also be a primary contact person for the ASCA office.";
        }
        if(ownershipType == OwnershipType.Kennel){
            return "Only the primary owner can request kennel ownership changes. They will also be a primary contact person for the ASCA office.";
        }
        if(ownershipType == OwnershipType.Litter){
            return "Only the primary owner can register and release puppies from the litter. They will also be a primary contact person for the ASCA office.";
        }
        return "";  
     }
  },
  props: {
    hideHeader: { type: Boolean },
    ownershipType: { type: Number },
    owners: { type: Array },
    hideContactInfo: { type: Boolean },
  },
});
</script>
